class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLDetailsElement} */
    this.mainDetailsToggle = /** @type {HTMLDetailsElement} */ (this.querySelector('details'));
    /** @type {Element | null} */
    this.content = /** @type {HTMLElement} */ (this.mainDetailsToggle.querySelector('summary')).nextElementSibling;
    /** @type {Animation[] | undefined} */
    this.animations = undefined;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {this.close();}
    });
  }

  onToggle() {
    if (!this.animations) {this.animations = /** @type {Element} */ (this.content).getAnimations();}

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((/** @type {Animation} */ animation) => animation.play());
    } else {
      this.animations.forEach((/** @type {Animation} */ animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    /** @type {HTMLElement} */ (this.mainDetailsToggle.querySelector('summary')).setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    /** @type {HTMLElement & { preventHide?: boolean } | null} */
    this.header = /** @type {HTMLElement & { preventHide?: boolean } | null} */ (document.querySelector('.header-wrapper'));
  }

  onToggle() {
    if (!this.header) {return;}
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') {return;}
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
